import React from 'react';
import { Box } from '@mui/material';
import { useReportLayoutConfig } from '../../contexts/ReportLayoutContext.jsx';

export default function ReportWidget({ sectionKey, widgetKey, children }) {
  const layoutCtx = useReportLayoutConfig();

  const getSectionLayout = layoutCtx?.getSectionLayout;
  const getWidgetLayout = layoutCtx?.getWidgetLayout;

  const sectionLayout = getSectionLayout ? getSectionLayout(sectionKey) : null;
  const widgetLayout = getWidgetLayout ? getWidgetLayout(sectionKey, widgetKey) : null;

  // Visibilidade controlada pelo layout (se configurado)
  if (sectionLayout && sectionLayout.visible === false) {
    return null;
  }

  if (widgetLayout && widgetLayout.visible === false) {
    return null;
  }

  const density = widgetLayout?.density || sectionLayout?.density || null;
  const avoidBreak = widgetLayout?.avoidPageBreakInside === true;

  const sx = {};

  // Estilos específicos para impressão (densidade e quebra de página)
  const printStyles = {};

  if (avoidBreak) {
    printStyles.breakInside = 'avoid-page';
    printStyles.pageBreakInside = 'avoid';
    printStyles.WebkitColumnBreakInside = 'avoid';
  }

  if (density === 'compact') {
    printStyles['& .MuiTypography-body1, & .MuiTypography-body2'] = {
      fontSize: '0.8rem',
      lineHeight: 1.25,
    };
    printStyles['& .MuiTypography-subtitle1, & .MuiTypography-subtitle2'] = {
      fontSize: '0.85rem',
      lineHeight: 1.25,
    };
    printStyles['& .MuiTypography-caption'] = {
      fontSize: '0.7rem',
      lineHeight: 1.2,
    };

    printStyles['& .MuiCardContent-root'] = {
      paddingTop: 6,
      paddingBottom: 6,
    };

    printStyles['& .MuiTableCell-root'] = {
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 6,
      paddingRight: 6,
      '& .MuiTypography-root': {
        fontSize: '0.7rem',
        lineHeight: 1.2,
      },
    };
  }

  if (Object.keys(printStyles).length > 0) {
    sx['@media print'] = printStyles;
  }

  // Futuro: poderemos usar `density` para ajustar tipografia/paddings também em tela

  return <Box sx={sx}>{children}</Box>;
}
